import React, { useState } from "react";
import "./Admindirectory.css";
import Logs from "./Logs";
import AdminLeaves from "./AdminLeaves";
import ProfileTable from "./ProfileTable";
import AttendanceSummary from "./AttendanceSummary";


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Dashboard");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "LOGS":
        return <Logs />;
      case "LEAVES":
        return <AdminLeaves />;
      case "SUMMARY":
        return <AttendanceSummary title="Profile" />;
   
      default:
        return <Logs />;
    }
  };

  const tabs = [
    "LOGS",
    "LEAVES",
    "SUMMARY",
  
  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

